import { RemoteAuthentication } from 'data/usecases/authentication/remote-authentication';
import { type IAuthentication } from 'domain/usecases';
import { makeApiUrlAuthentication } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteAuthentication = (): IAuthentication => {
  return new RemoteAuthentication(
    makeApiUrlAuthentication(),
    makeAxiosHttpClient(),
  );
};
